import { render, staticRenderFns } from "./DicksSportingGoodPerformance.vue?vue&type=template&id=1119b140&"
import script from "./DicksSportingGoodPerformance.vue?vue&type=script&lang=js&"
export * from "./DicksSportingGoodPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports